import { Link } from 'react-router-dom';
import Button from '../../components/base/Button';
import Seo from '../../components/feature/Seo';
import { PHONE_HREF, servicePages, WHATSAPP_HREF } from '../../lib/schiek-content';

export default function LeistungenPage() {
  return (
    <main className="bg-white pt-28 pb-20">
      <Seo
        title="Leistungen | Abschleppdienst Schiek Berlin"
        description="Abschleppdienst Schiek hilft in Berlin bei Pannenhilfe, Unfallbergung, Falschparkern, Fahrzeugtransport, Tiefgarage und Motorradtransport."
        path="/leistungen"
      />

      <section className="px-5" aria-labelledby="services-heading">
        <div className="mx-auto max-w-6xl rounded-[2rem] border border-slate-200 bg-slate-50 p-6 md:p-10">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.24em] text-[#0F3D8C]">Leistungen</p>
          <h1 id="services-heading" className="max-w-4xl text-3xl font-semibold leading-tight text-slate-950 sm:text-5xl">
            Abschleppdienst Berlin für Panne, Unfall, Falschparker und Transport
          </h1>
          <p className="mt-5 max-w-3xl text-base leading-relaxed text-slate-700 sm:text-lg">
            Schiek ist ein privater Abschlepp- und Bergungsdienst in Berlin. Sie beauftragen uns direkt, ohne
            Vermittlungsplattform und ohne Clubstruktur.
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Button href={PHONE_HREF} size="lg" className="whitespace-normal px-6 text-sm">
              Jetzt anrufen
            </Button>
            <Button href={WHATSAPP_HREF} variant="secondary" size="lg" className="whitespace-normal px-6 text-sm">
              WhatsApp schreiben
            </Button>
          </div>
        </div>
      </section>

      <section className="px-5 py-16" aria-labelledby="services-list-heading">
        <div className="mx-auto max-w-6xl">
          <h2 id="services-list-heading" className="text-2xl font-semibold text-slate-950 sm:text-3xl">
            Wobei Schiek hilft
          </h2>
          <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {servicePages.map((service) => (
              <article
                key={service.slug}
                className="flex h-full flex-col rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_16px_42px_rgba(15,23,42,0.06)] transition-transform duration-200 hover:-translate-y-1"
              >
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0F3D8C]">{service.eyebrow}</p>
                <h3 className="mt-3 text-xl font-semibold text-slate-950">{service.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-700">{service.summary}</p>
                <Link
                  to={`/leistungen/${service.slug}`}
                  className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#0F3D8C] hover:underline"
                >
                  Details öffnen
                  <span aria-hidden="true">→</span>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="px-5">
        <div className="mx-auto max-w-6xl rounded-[2rem] bg-slate-950 p-6 text-white md:p-8">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sky-300">Direkte Beauftragung</p>
          <h2 className="mt-3 text-2xl font-semibold sm:text-3xl">Privater Abschleppdienst ohne Clubstruktur</h2>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-slate-200 sm:text-base">
            Schiek arbeitet direkt mit Ihnen als Auftraggeber. Wir rechnen nicht über Clubkarten, Mitgliedsnummern
            oder Gutscheinsysteme ab. Dafür gibt es klare Kommunikation, direkte Abstimmung und nachvollziehbare
            Abwicklung.
          </p>
        </div>
      </section>
    </main>
  );
}
